import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import { Services } from "../pages/Services";
import { Dashboard, Login, ResetPassword } from "../pages/Dashboard";
import {
  ParkingManagement,
  AddParkingSlot,
  AssignParkingSlot,
  GenerateParkingSlots,
} from "../pages/Parking";
import { PrivacyPolicy, TermsConditions } from "../pages/legal";
import { Settings } from "../pages/Settings";
import {
  SocietyManagement,
  AddSociety,
  SocietyAdmin,
  FloorSummary,
} from "../pages/Society";
import {
  UserManagement,
  AddAdmin,
  ResidentImport,
} from "../pages/User";
import { TowerManagement } from "../pages/Tower";
import { UnitManagement } from "../pages/Unit";
import {
  PropertyExplorer,
  DepartmentDetail,
  StoreDetail,
} from "../pages/Property";
import {
  Amenities,
  AddAmenity,
  ResidentAmenities,
  ResidentMyBookings,
} from "../pages/Amenities";
import {
  GuardVisitors,
  GuardExpectedVisitors,
  ResidentVisitors,
  PublicVisitorCheckin,
  PublicVisitorStatus,
} from "../pages/Visitor";
import { SystemLogs } from "../pages/SystemLogs";
import {
  AdminGateEntryLogs,
  ResidentMyInvites,
  CreateInvite,
  InviteDetails,
} from "../pages/Invites";
import { Profile } from "../pages/Profile";
import {
  Support,
  ResidentSupportTickets,
  CreateSupportTicket,
} from "../pages/SupportTicket";
import DatabaseViewer from "../pages/DatabaseViewer";
import { SocietyChatsWrapper } from "../pages/Community";
import { SendNotifications } from "../pages/Notifications";
import {
  MasterDeliveryCompanies,
  MasterCabProviders,
  MasterPropertyTypes,
  MasterDepartments,
} from "../pages/Masters";

const withProtection = (element, access = {}) => (
  <ProtectedRoute access={access}>{element}</ProtectedRoute>
);

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/visitor/checkin" element={<PublicVisitorCheckin />} />
        <Route path="/visitor/status/:code" element={<PublicVisitorStatus />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={withProtection(<Profile />)} />
        <Route path="/dashboard" element={withProtection(<Dashboard />)} />
        <Route path="/admin/invites" element={withProtection(<AdminGateEntryLogs />)} />
        <Route
          path="/society-chats"
          element={withProtection(<SocietyChatsWrapper />, {
            roles: [
              "admin",
              "super-admin",
              "society-admin",
              "society-manager",
              "user",
              "owner",
              "tenant",
              "family-member",
              "resident",
            ],
          })}
        />

        <Route
          path="/users"
          element={withProtection(<UserManagement />, {
            roles: ["admin", "super-admin", "society-admin", "society-manager"],
            permission: "canManageUsers",
          })}
        />
        <Route
          path="/users/import"
          element={withProtection(<ResidentImport />, {
            roles: ["admin", "super-admin", "society-admin", "society-manager"],
            permission: "canManageUsers",
          })}
        />
        <Route
          path="/residents"
          element={<Navigate to="/users" replace />}
        />
        <Route
          path="/residents/import"
          element={<Navigate to="/users/import" replace />}
        />
        <Route
          path="/user-management"
          element={<Navigate to="/users" replace />}
        />
        {/* <Route
          path="/add-user"
          element={withProtection(<AddUser />, {
            roles: ["admin", "super-admin", "society-admin", "society-manager"],
            permission: "canManageUsers",
          })}
        /> */}
        <Route
          path="/add-admin"
          element={withProtection(<AddAdmin />, {
            roles: ["admin", "super-admin"],
          })}
        />
        <Route
          path="/properties"
          element={withProtection(<PropertyExplorer />, {
            roles: ["super-admin", "society-admin", "society-manager", "chairman", "secretary", "treasurer"],
            permission: "canManagePropertyDetails",
          })}
        />
        <Route
          path="/properties/department/:unitId"
          element={withProtection(<DepartmentDetail />, {
            roles: ["super-admin", "society-admin", "society-manager", "chairman", "secretary", "treasurer"],
            permission: "canManagePropertyDetails",
          })}
        />
        <Route
          path="/properties/store/:unitId"
          element={withProtection(<StoreDetail />, {
            roles: ["super-admin", "society-admin", "society-manager", "chairman", "secretary", "treasurer"],
            permission: "canManagePropertyDetails",
          })}
        />


        <Route
          path="/society-management"
          element={withProtection(<SocietyManagement />, {
            roles: ["super-admin"],
            permission: "canManagePropertyDetails",
          })}
        />
        <Route
          path="/add-society"
          element={withProtection(<AddSociety />, {
            roles: ["super-admin"],
            permission: "canManagePropertyDetails",
          })}
        />
        <Route
          path="/society-admin"
          element={withProtection(<SocietyAdmin />, {
            roles: ["admin", "super-admin", "society-admin"],
            permission: "canManageUsers",
          })}
        />
        <Route
          path="/floor-summary"
          element={withProtection(<FloorSummary />, {
            roles: ["admin", "super-admin", "society-admin", "society-manager"],
          })}
        />
        <Route
          path="/tower-management"
          element={withProtection(<TowerManagement />, {
            roles: ["admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/unit-management"
          element={withProtection(<UnitManagement />, {
            roles: ["admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/amenities"
          element={withProtection(<Amenities />, {
            roles: [
              "admin",
              "super-admin",
              "society-admin",
              "society-manager",
              "maintenance-staff",
              "resident",
              "user"
            ],
            permission: "canManageServiceBookings",
          })}
        />
        <Route
          path="/services"
          element={withProtection(<Services />, {
            roles: [
              "admin",
              "super-admin",
              "society-admin",
              "society-manager",
              "resident",
              "user",
            ],
            permission: "canManageServiceBookings",
          })}
        />
        <Route
          path="/masters/delivery-companies"
          element={withProtection(<MasterDeliveryCompanies />, {
            roles: ["admin", "super-admin"],
          })}
        />
        <Route
          path="/masters/cab-providers"
          element={withProtection(<MasterCabProviders />, {
            roles: ["admin", "super-admin"],
          })}
        />
        <Route
          path="/masters/property-types"
          element={withProtection(<MasterPropertyTypes />, {
            roles: ["super-admin"],
          })}
        />
        <Route
          path="/masters/departments"
          element={withProtection(<MasterDepartments />, {
            roles: ["admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/send-notifications"
          element={withProtection(<SendNotifications />, {
            roles: ["admin", "super-admin", "society-admin"],
            permission: "canManageNotices",
          })}
        />
        <Route
          path="/add-amenity"
          element={withProtection(<AddAmenity />, {
            roles: [
              "admin",
              "super-admin",
              "society-admin",
              "society-manager",
              "maintenance-staff",
            ],
            permission: "canManageServiceBookings",
          })}
        />
        <Route
          path="/parking-management"
          element={withProtection(<ParkingManagement />, {
            roles: [
              "admin",
              "super-admin",
              "society-admin",
              "society-manager",
              "guard",
            ],
            permission: "canManageVehicleTracking",
          })}
        />
        <Route
          path="/add-parking-slot"
          element={withProtection(<AddParkingSlot />, {
            roles: [
              "admin",
              "super-admin",
              "society-manager",
              "guard",
            ],
            permission: "canManageVehicleTracking",
          })}
        />
        <Route
          path="/generate-parking-slots"
          element={withProtection(<GenerateParkingSlots />, {
            roles: ["admin", "super-admin", "society-manager"],
            permission: "canManageVehicleTracking",
          })}
        />
        <Route
          path="/assign-parking-slot"
          element={withProtection(<AssignParkingSlot />, {
            roles: [
              "admin",
              "super-admin",
              "society-manager",
              "guard",
            ],
            permission: "canManageVehicleTracking",
          })}
        />
        <Route
          path="/support"
          element={withProtection(<Support />, {
            roles: [
              "admin",
              "super-admin",
              "society-admin",
              "society-manager",
              "help-desk",
              "guard",
              "user",
              "owner",
              "tenant",
              "family-member",
              "resident",
            ],
            permission: "canManageFeedback",
          })}
        />
        <Route
          path="/resident/support-tickets"
          element={withProtection(<ResidentSupportTickets />, {
            roles: ["user", "owner", "tenant", "family-member", "resident"],
          })}
        />
        <Route
          path="/resident/support-tickets/new"
          element={withProtection(<CreateSupportTicket />, {
            roles: ["user", "owner", "tenant", "family-member", "resident"],
          })}
        />
        <Route
          path="/settings"
          element={withProtection(<Settings />, {
            roles: ["admin", "super-admin"],
          })}
        />
        <Route
          path="/system-logs"
          element={withProtection(<SystemLogs />, {
            roles: ["super-admin"],
            permission: "canViewSystemLogs",
          })}
        />

        <Route
          path="/terms-conditions"
          element={<TermsConditions />}
        />
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />
        <Route
          path="/guard/expected-visitors"
          element={withProtection(<GuardExpectedVisitors />, {
            roles: ["admin", "super-admin", "society-admin", "guard", "security-head"],
          })}
        />
        <Route
          path="/guard/visitors"
          element={withProtection(<GuardVisitors />, {
            roles: ["guard", "admin", "super-admin", "society-admin", "society-manager"],
            permission: "canManageVisitors",
          })}
        />
        <Route
          path="/resident/visitors"
          element={withProtection(<ResidentVisitors />, {
            roles: ["user", "owner", "tenant", "resident", "admin", "super-admin", "society-admin"],
          })}
        />

        <Route
          path="/resident/amenities"
          element={withProtection(<ResidentAmenities />, {
            roles: ["user", "owner", "tenant", "resident", "admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/resident/my-bookings"
          element={withProtection(<ResidentMyBookings />, {
            roles: ["user", "owner", "tenant", "resident", "admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/resident/invites"
          element={withProtection(<ResidentMyInvites />, {
            roles: ["user", "owner", "tenant", "resident", "admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/resident/invites/new"
          element={withProtection(<CreateInvite />, {
            roles: ["user", "owner", "tenant", "resident", "admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/resident/invites/:id"
          element={withProtection(<InviteDetails />, {
            roles: ["user", "owner", "tenant", "resident", "admin", "super-admin", "society-admin"],
          })}
        />
        <Route
          path="/admin/gate-entry-logs"
          element={withProtection(<AdminGateEntryLogs />, {
            roles: ["admin", "super-admin"],
            permission: "canManageVisitors",
          })}
        />
        <Route
          path="/databaseviewer"
          element={withProtection(<DatabaseViewer />, {
            roles: ["admin", "super-admin"],
          })}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
